// --- Modules
import Node, { payload } from './Node';

class User extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'User'
    });
  }
};

export default {
  create: (opts) => {
    let item = new User(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
